import { CommunityId } from "@sp-crm/core";
import { Icon } from "components/icon";
import {
    EvergreenCommunityListingAvailability,
    FindOrCreateCommunityInsightsMutation,
} from "generated/graphql";
import React from "react";
import { CommunityAvailabilityExisting } from "./community-availability-existing";
import { CommunityAvailabilityMissing } from "./community-availability-missing";

interface CommunityInsightsAvailabilityProps {
    listing: FindOrCreateCommunityInsightsMutation["findOrCreateCommunityInsights"];
    communityId: CommunityId;
}

export const CommunityInsightsAvailability = (
    props: CommunityInsightsAvailabilityProps,
) => {
    const { listing, communityId } = props;

    return (
        <>
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                    <div className="w-7">
                        <Icon name="42_ClientAndCommunity" />
                    </div>
                    <span className="text-lg text-gray-700">Availability</span>
                </div>
            </div>
            {listing.availability?.status ===
            EvergreenCommunityListingAvailability.Unknown ? (
                <CommunityAvailabilityMissing
                    listing={listing}
                    communityId={communityId}
                />
            ) : (
                <CommunityAvailabilityExisting
                    listing={listing}
                    communityId={communityId}
                />
            )}
        </>
    );
};
